module.exports = __webpack_public_path__ + "img/product-ketang-kjxl-01.7fc044c6.png";